import moment from 'moment';
import {TableColumn} from 'element-ui/types/table-column.d';
import { ORIGIN_FORMAT } from './index';


export namespace ELTABLE_FORMAT {
    export const DateFormatBrief = (row: any, column: TableColumn): string => {
        return ORIGIN_FORMAT.DateFormatOrigin(row[column.property]);
    };

    export const DateFormat = (row: any, column: TableColumn): string => {
        return ORIGIN_FORMAT.DateFormatMinuteOrigin(row[column.property]);
    };

    export const DateFormatDetail = (row: any, column: TableColumn): string => {
        return ORIGIN_FORMAT.DateFormatDetailOrigin(row[column.property]);
    };

    export const NumberFormat = (row: any, column: TableColumn): string => {
        return ORIGIN_FORMAT.NumberFormatOrigin(row[column.property]);
    };
}